import script from "./PcFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PcFooter.vue?vue&type=script&setup=true&lang=js"

import "./PcFooter.vue?vue&type=style&index=0&id=e880a582&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e880a582"]])

export default __exports__